module.exports = __webpack_public_path__ + "static/media/defense.33bf631b.svg";